export default __webpack_public_path__ + "static/media/95_desktop.ff40929d.jpg";